<template>
  <div class="home-power-players">
    <BContainer class="px-1 px-md-3">
      <b-modal ref="modal-menu" hide-footer id="modal-menu" title="Overflowing Content">
        <template #modal-title>
          <IconCompass />  {{ $t('list.exploreBy') }}
        </template>
        <div class="accordion regions-filter" role="tablist">
          <BCard no-body class="mb-1">
            <BCardHeader header-tag="header" class="p-1" role="tab">
              <BButton block v-b-toggle.accordion-regions variant="dark" class="d-flex flex-rows align-items-center justify-content-center">
                <IconWorld class="mr-2" />
                {{ $t('list.regionLabel') }}
              </BButton>
            </BCardHeader>
            <BCollapse id="accordion-regions" ref="accordion-regions" :visible="validateCollapse($route.query.region)" accordion="accordion-filter" role="tabpanel">
                <BFormGroup>
                  <BFormRadioGroup
                  id="btn-radios-3"
                  v-model="regionSelected"
                  :options="regions"
                  name="radio-btn-stacked"
                  buttons
                  stacked />
              </BFormGroup>
            </BCollapse>
          </BCard>

          <BCard no-body>
            <BCardHeader header-tag="header" class="p-1" role="tab">
              <BButton block v-b-toggle.accordion-providers variant="dark" class="d-flex flex-rows align-items-center justify-content-center">
                <IconSecrecyBroker class="mr-2" />
                {{ $t('list.brokersLabel') }}
               </BButton>
            </BCardHeader>
            <BCollapse id="accordion-providers" ref="accordion-providers" :visible="validateCollapse($route.query.provider)" accordion="accordion-filter" role="tabpanel">
              <BFormGroup>
                <BFormRadioGroup
                id="btn-radios-4"
                v-model="providerSelected"
                :options="providers"
                name="radio-btn-stacked"
                buttons
                stacked />
            </BFormGroup>
            </BCollapse>
          </BCard>

          <BCard no-body>
            <BCardHeader header-tag="header" class="p-1" role="tab">
              <BButton block v-b-toggle.accordion-countries variant="dark" class="d-flex flex-rows align-items-center justify-content-center">
                <IconCountry class="mr-2" />
                {{ $t('list.jurisdictionLabel') }}
              </BButton>
            </BCardHeader>
            <BCollapse id="accordion-countries" :visible="validateCollapse($route.query.country)" accordion="accordion-filter" role="tabpanel">
              <BFormGroup>
                <BFormRadioGroup
                id="btn-radios-5"
                v-model="countrySelected"
                :options="countries"
                name="radio-btn-stacked"
                buttons
                stacked />
              </BFormGroup>
            </BCollapse>
          </BCard>

          <AboutLinks />
        </div>
      </b-modal>
      <BRow align-h="end" class="justify-content-center align-self-center">
        <BCol cols="12" md="8" sm="9">

          <BRow class="mb-3">
            <BCol cols="12" v-if="$route.query.region">
              <h2>{{ this.translateRegion(regionSelected) }}</h2>
              <div>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. <RouterLink :to="{ name: 'region.page', params: { region_id: regionSelected } }">{{ this.translateRegion(regionSelected) }}</RouterLink>
                </p>
              </div>
            </BCol>

            <BCol cols="12" v-if="$route.query.provider">
              <h2>{{ this.translateProvider(providerSelected) }}</h2>
              <div>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. <RouterLink :to="{ name: 'provider.page', params: { provider_id:providerSelected } }">{{ this.translateProvider(providerSelected)}}</RouterLink>
                </p>
              </div>
            </BCol>

            <BCol cols="12" v-if="$route.query.country">
              <h2>{{ this.translateIsoCountry(countrySelected) }}</h2>
              <div>
                <p>
                  {{ $t('list.jurisdictionDisclaimer') }}
                </p>
              </div>
            </BCol>
          </BRow>

          <BCol cols="12" class="pb-5 d-block d-sm-block d-md-block float-filter">
            <b-button block class="mt-3"  v-b-modal.modal-menu>
             <IconCompass />  {{ $t('list.exploreBy') }}
            </b-button>
          </BCol>

          <PlayersGrid :players="clients" />
        </BCol>
      </BRow>
    </BContainer>
    <AppFooterEmbed /> 
  </div>
</template>

<script>
import { get, kebabCase, map, trim, isEmpty } from 'lodash'
import AppFooterEmbed from '@/components/AppFooterEmbed'
import IconWorld from '@/components/IconWorld'
import IconCompass from '@/components/IconCompass'
import IconSecrecyBroker from '@/components/IconSecrecyBroker'
import IconCountry from '@/components/IconCountry'
import AboutLinks from '@/components/AboutLinks.vue'
import PlayersGrid from '@/components/PlayersGrid.vue'
import utils from '@/mixins/utils'

export default {
  name: 'HomeEmbed',
  mixins: [utils],
  data() {
    return {
      regionSelected: 'all',
      providerSelected: 'all',
      countrySelected: 'all'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {      
      if(to.query.country)
        vm.$store.commit('players/filterByCountry', get(to.query, 'country', null))
      if(to.query.provider)
        vm.$store.commit('players/filterByProvider', get(to.query, 'provider', null))
      if(to.query.region)
        vm.$store.commit('players/filterByRegion', get(to.query, 'region', null))
    })
  },
  beforeRouteUpdate (to, from, next) {
    if(to.query.country)
      this.$store.commit('players/filterByCountry', get(to.query, 'country', null))
    if(to.query.provider)
      this.$store.commit('players/filterByProvider', get(to.query, 'provider', null))
    if(to.query.region)
      this.$store.commit('players/filterByRegion', get(to.query, 'region', null))
    next()
  },
  components: {
    AppFooterEmbed,
    IconWorld,
    IconCompass,
    IconSecrecyBroker,
    IconCountry,
    AboutLinks,
    PlayersGrid
  },
  watch: {
    regionSelected(val) {
      this.selectRegion(val)
      this.$refs['modal-menu'].hide()
    },
    providerSelected(val) {
      this.selectProvider(val)
      this.$refs['modal-menu'].hide()
    },
    countrySelected(val) {
      this.selectCountry(val)
      this.$refs['modal-menu'].hide()
    }
  },
  mounted() {
    if(isEmpty(this.$route.query) &&
      this.$refs['accordion-regions']) {
        this.$refs['accordion-regions'].show = true
    } else {
      if(this.$route.query.region) {
        this.regionSelected = this.$route.query.region
      }
      if(this.$route.query.provider) {
        this.providerSelected= this.$route.query.provider
      }
      if(this.$route.query.country) {
        this.countrySelected = this.$route.query.country
      }
    }
  },
  computed: {
    clients () {
      return this.$store.state.players.filtered
    },
    countries () {
      const countries = map(this.$store.state.players.countries, country => {
        return { value: country.country_id, text: `${this.translateIsoCountry(country.country_id)} (${country.players.length })`, count: country.players.length }
      })

      countries.unshift({ value: '', text: this.$t('global.all') })
      return countries
    },
    providers () {
      const countries = map(this.$store.state.players.providers, provider => {
        return { value: provider.provider_id, text: provider.provider }
      })

      countries.unshift({ value: '', text: this.$t('global.all') })
      return countries
    },
    regions () {

      const regions = map(this.$store.state.players.regions, region => {
        return { value: region.region_id, text: `${this.translateRegion(region.region_id)} (${region.players.length })`, count: region.players.length }
      })

      regions.unshift({ value: 'all', text: this.$t('global.all') })

      return regions
    }
  },
  methods: {
    kebabCase,
    validateCollapse(path) {
      if(this.$route.name == 'list' && !isEmpty(path)) {
        return true
      }
    },
    career (player) {
      if(player.career)
        return map(player.career.split(';'), title => trim(title))[0]
      return ``
    },
    selectRegion (region) {
      if(region != this.$route.query.region) {
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: { region } })
      }
    },
    selectProvider (provider) {
      if(provider != this.$route.query.provider) {
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: { provider } })
      }      
    },
    selectCountry (country) {
      if(country != this.$route.query.country) {
        this.$router.push({ name: this.$route.name, params: this.$route.params, query: { country } })
      }        
    }
  }
}
</script>

<style lang="scss">

  #app {
    height: 100vh; 
    overflow-y: auto;
  }

  .regions-filter {
    min-height: 80vh;
    span {
      font-size: 14px;
    }

    label {
      margin-bottom: 5px;
    }

    .global-menu-about {
      width: 100%;
    }

    .btn-secondary {
      margin-bottom: 3px !important;
      color: #000;
      background: transparent;
      border: none;

      &.active {
        background: var(--app-color-red) !important;
      }

    }

    .btn-group-toggle {
      width: 100%;
    }

    .collapse {
      width: 100%;
      max-height: 45vh;
      overflow-y: auto;
    }
  }

  .player-item {
    &__title {
      font-size: 18px;
    }

    &__name {
      font-size: 15px;
      color: var(--app-color-red);
    }
  }

  .header-region {
    border-bottom: solid 1px var(--app-color-dark);
  }

  .float-filter {
    position: sticky;
    top: 85px;
    z-index: 99;
  }

  .home-power-players {
    color: var(--app-color-black);
    font-weight: 300;
    min-height: 100%;

    &__region {
      height: 320px;
      color: var(--app-color);
      background-color: var(--app-color-red);
    }

    &__banner_top {
      padding: 85px 0;
      color: var(--app-color);
      background-color: var(--app-color-orange);
    }

    &__content_secondary {
      padding: 85px 0;
      color: var(--app-color-dark);
      background-color: var(--app-color);
    }

    &__pre_footer {
      padding: 85px 0;
      color: var(--app-color-dark);
      background-color: var(--app-color);
    }

    &__intro {
      font-size: 21px;
      font-weight: 300;
    }

    &__filters {
      &__title {
        font-size: 0.9rem;
        vertical-align: baseline;
      }

      &__dropdown {
        .dropdown-toggle {
          background-color: #000;
          color: white;
          max-width: 100%;
          padding: 0 4px;
          width: 166px;
        }

        &--default .dropdown-toggle {
          background-color: #808080;
        }

        .dropdown-menu {
          max-height: 50vh;
          overflow-y: auto;
        }
      }
    }

    @media (min-width: 768px) {
      .home-power-players__filters__dropdown__text {
        text-align: left;
      }
    }
  }
</style>
